import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import type { ReduxStore, ReduxNext } from '@makemydeal/dr-shared-store';
import { FETCH_DEAL_SUMMARY_PDF_REQUEST, FETCH_DEAL_SUMMARY_PDF_SUCCESS } from '@makemydeal/activities-request-proposal';
import { Actions, DealXgSocketActions, getDealXgVersion, getPublishedVersion } from '@makemydeal/dr-sales-checkin-store';
import type { DealSummaryPdfStage } from '@makemydeal/dr-shared-ui-utils';
import { markDealSummaryPdfStage, setDealSummaryPdfTimingContext } from '@makemydeal/dr-shared-ui-utils';

const STAGE_BY_ACTION_TYPE: Record<string, DealSummaryPdfStage> = {
    [DealXgSocketActions.SOCKET_EVENT_RECEIVED]: 'socketEventReceived',
    [DealXgSocketActions.SHOW_DEAL_REFRESH_MODAL]: 'refreshModalShown',
    [DealXgSocketActions.REFRESH_DEAL_REQUESTED]: 'refreshRequested',
    [Actions.FETCH_DEAL_SUCCESS]: 'dealFetched',
    [FETCH_DEAL_SUMMARY_PDF_REQUEST]: 'pdfFetchRequested',
    [FETCH_DEAL_SUMMARY_PDF_SUCCESS]: 'pdfUrlReceived'
};

export const dealSummaryPdfTimingMiddleware = (store: ReduxStore<any>) => (next: ReduxNext) => (action: AnyFSA) => {
    const stage = STAGE_BY_ACTION_TYPE[action.type];

    if (stage) {
        markDealSummaryPdfStage(stage);
    }

    const result = next(action);

    if (stage === 'pdfUrlReceived') {
        const state = store.getState();
        setDealSummaryPdfTimingContext({
            dealXgVersion: getDealXgVersion(state),
            publishedVersion: getPublishedVersion(state)
        });
    }

    return result;
};
